import { Avatar } from 'primereact/avatar'
import { Button } from 'primereact/button'
import { useState } from 'react'
import { useAuthContext } from '../../../context/AuthContext'

import { ReloginForm } from '../../dialogs/ui/ReloginForm'
import { UserInfoData } from './user-info-data/user-info-data'
import styles from './user-info.module.css'

export const UserInfo = () => {
	const { logout, userRole } = useAuthContext()

	const handleLogout = async () => {
		await logout()
	}

	const [showReloginDialog, setShowReloginDialog] = useState(false)

	return (
		<div className={styles.user_info__container}>
			<div className={styles.user_info__block}>
				<UserInfoData />
				<Avatar icon='pi pi-user'></Avatar>
				{userRole !== 'usr' && (
					<Button
						style={{
							height: 33,
							width: 33,
							padding: 0,
						}}
						icon='pi pi-sync'
						rounded
						severity='secondary'
						onClick={() => {
							setShowReloginDialog(true)
						}}
					/>
				)}
				<Button
					text
					icon='pi pi-sign-out'
					severity='secondary'
					data-at-wc-auth-logout
					onClick={handleLogout}
					style={{
						height: 33,
						width: 33,
						padding: 0,
					}}
				/>
			</div>

			{showReloginDialog && userRole !== 'usr' && (
				<ReloginForm
					show={showReloginDialog}
					close={() => setShowReloginDialog(false)}
					reloginType='rebot'
				/>
			)}
		</div>
	)
}
